// src/app/shared/athlete-param.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CurrentAthleteService } from './current-athlete.service';

/**
 * Hängt ?user_id=… an API-Requests an, wenn im CurrentAthleteService
 * eine Athlete-ID gesetzt ist. Damit funktioniert effective_user_id
 * serverseitig auch fürs Dashboard.
 */
export const athleteParamInterceptorFn: HttpInterceptorFn = (req, next) => {
  // Nur für unsere Backend-API (verhindert Anhängen bei CDNs etc.)
  // Greift sowohl bei absoluten (http://.../api/...) als auch relativen (/api/...) URLs.
  //
  // /api/admin/** ist ausgenommen: diese Views werten ausschliesslich den
  // angemeldeten Nutzer aus (request_user_id / request.user), nie
  // effective_user_id. Ohne die Ausnahme hinge die Korrektheit der
  // Administration daran, dass das serverseitig auch so bleibt — ein Admin
  // trägt seinen Athletenkontext ja mit in den Admin-Bereich.
  if (!req.url.includes('/api/') || req.url.includes('/api/admin/')) {
    return next(req);
  }

  // Versuche die aktuelle Athlete-ID zu holen
  let athleteId: number | null = null;
  try {
    const svc = inject(CurrentAthleteService);
    athleteId = svc.getCurrentId(); // synchroner Snapshot
  } catch {
    // Service nicht verfügbar → nichts anhängen
  }

  if (athleteId == null) {
    return next(req);
  }

  // Wenn bereits vorhanden, nicht doppelt anhängen
  if (req.params.has('user_id')) {
    return next(req);
  }

  const cloned = req.clone({
    params: req.params.set('user_id', String(athleteId)),
  });
  return next(cloned);
};
